import { QueryList } from '@angular/core';
import { AccordionComponent } from './accordion.component';
var AccordionGroupComponent = /** @class */ (function () {
    function AccordionGroupComponent() {
        this.subscriptions = [];
    }
    AccordionGroupComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._accordions = this.accordions;
        this.removeSubscriptions();
        this.addSubscriptions();
        this.accordions.changes.subscribe(function (rex) {
            _this._accordions = rex;
            _this.removeSubscriptions();
            _this.addSubscriptions();
        });
    };
    AccordionGroupComponent.prototype.addSubscriptions = function () {
        var _this = this;
        this._accordions.forEach(function (a) {
            var subscription = a.toggleAccordion.subscribe(function (e) {
                _this.toogleAccordion(a);
            });
            _this.subscriptions.push(subscription);
        });
    };
    AccordionGroupComponent.prototype.removeSubscriptions = function () {
        this.subscriptions.forEach(function (sub) {
            sub.unsubscribe();
        });
    };
    AccordionGroupComponent.prototype.toogleAccordion = function (accordion) {
        if (!accordion.active) {
            this.accordions.forEach(function (a) { return a.active = false; });
        }
        // set active accordion
        accordion.active = !accordion.active;
    };
    AccordionGroupComponent.prototype.ngOnDestroy = function () {
        this.removeSubscriptions();
    };
    return AccordionGroupComponent;
}());
export { AccordionGroupComponent };
